/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: BI Dashboard
 *| (C) Copyright IBM Corp. 2017, 2019
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

/**
 * This Class encapsulates raw query result data returned from DSS and provides its accessors and iterators
 **/
define(['../../../lib/@waca/core-client/js/core-client/ui/core/Class',
	'../../../lib/@waca/dashboard-common/dist/query/FacetDataObject',
	'underscore'], function(BaseClass, FacetData,  _) {
	'use strict';

	var SingleQueryResult = BaseClass.extend({
		_facetData: null, /*QueryResultData Object*/
		_queryThreshHold: 3000,
		_attachedPayload: null,
		_dataViewId: null,

		init: function(dataViewId, queryResultData, queryThreshold, attachedPayload, queryResultAPI) {
			this._queryThreshHold = queryThreshold;
			this._facetData = queryResultData;
			this._attachedPayload = attachedPayload;
			this._dataViewId = dataViewId;
			this.data = queryResultData;//TODO: Remove this in Endor
			this._queryResultAPI = queryResultAPI;
		},

		getFacetData: function() {
			return this._facetData;
		},

		getQueryThreshhold: function() {
			return this._queryThreshHold;
		},

		getTopBottomMappings: function() {
			return this._attachedPayload ? this._attachedPayload.topBottomMappings : {};
		},

		setTopBottomMappings: function(topBottomMappings) {
			this._attachedPayload = this._attachedPayload || {};
			this._attachedPayload.topBottomMappings = topBottomMappings;
		},

		getAttachedPayload: function() {
			return this._attachedPayload;
		},

		getHasMoreData: function() {
			return this._facetDdata ? this._faectData.hasMoreData() : false;
		},

		getDataViewId: function() {
			return this._dataViewId;
		},

		// TODO temporarily provide an API to get the new QueryResultAPI
		getQueryResult: function() {
			return this._queryResultAPI;
		}

	});

	var QueryResultObject = BaseClass.extend({
		_renderContext: null,

		hasMoreData: false,
		queryThreshold: Number.MAX_VALUE,

		init: function(renderContext) {
			this._aQueryResults = [];
			this._renderContext = renderContext;
		},

		addQueryResultObject: function(dataViewId, queryResultData, queryThreshold, attachedPayload, queryResultAPI) {
			this._aQueryResults.push(new SingleQueryResult(dataViewId, queryResultData, queryThreshold, attachedPayload, queryResultAPI));

			// summarize the clipping information among multiple query results
			this.hasMoreData = this.hasMoreData || queryResultData.hasMoreData();
			this.queryThreshold = Math.min(this.queryThreshold, queryThreshold);
		},

		getQueryResultByDataViewId: function(dataViewId) {
			return _.find(this._aQueryResults, function(entry) {
				return entry.getDataViewId() === dataViewId;
			});
		},

		getQueryResultByIndex: function(index) {
			return this._aQueryResults[index];
		},

		getDefaultQueryResult: function() {
			return this._aQueryResults[0];
		},

		getQueryResults: function() {
			return this._aQueryResults;
		},

		getRenderContext: function() {
			return this._renderContext;
		},

		/**
		 * set top bottom mapping from top bottom spec
		 * @param {Object} topBottomSpec
		 * @param {int} index - optional. default to 0 if not set
		 * eg. { Quantityavg: {
		 *			max: xx,
		 * 			min: xx
		 * 		}, {
		 * 		UnitCostsum: {
		 * 			max: xx,
		 * 			min: xx }
		 * 		} }
		 */
		setTopBottomMappings: function(topBottomSpec, index) {
			let topBottomMapping = {};
			_.each(topBottomSpec, function(value, key){
				var facetDataItemMax = new FacetData({ u: value.max });
				var facetDataItemMin = new FacetData({ u: value.min });
				topBottomMapping[key] = {
					bottomResult: facetDataItemMin,
					topResult: facetDataItemMax
				};
			});
			let queryResult = this.getQueryResultByIndex(index || 0);
			queryResult.setTopBottomMappings(topBottomMapping);
		}
	});

	return QueryResultObject;
});
